<template>
  <div class="confirm-modal-overlay" v-if="visible" @click.self="cancel">
    <div class="confirm-modal-card">
      <div class="confirm-icon">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 8v5"/>
          <circle cx="12" cy="16" r="1"/>
        </svg>
      </div>
      <h1 class="confirm-title">{{ title }}</h1>
      <p class="confirm-message">{{ message }}</p>
      <div class="confirm-actions">
        <button class="btn btn-secondary btn-lg" @click="cancel">{{ cancelText }}</button>
        <button class="btn btn-primary btn-lg" @click="confirm">{{ confirmText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  computed: {
    modal() {
      return this.$store.state.confirmModal || {}
    },
    visible() {
      return !!this.modal.visible
    },
    title() {
      return this.modal.title || this.$t('common.confirm')
    },
    message() {
      return this.modal.message || ''
    },
    confirmText() {
      return this.modal.confirmText || '确认'
    },
    cancelText() {
      return this.modal.cancelText || '取消'
    }
  },
  methods: {
    confirm() {
      this.$store.dispatch('confirmModalConfirm')
    },
    cancel() {
      this.$store.dispatch('confirmModalCancel')
    }
  }
}
</script>

<style scoped>
.confirm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease;
}
.confirm-modal-card {
  max-width: 560px;
  width: min(560px, calc(100vw - 32px));
  text-align: center;
  padding: 40px 32px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-xl);
  animation: slideUp 0.3s ease;
}
.confirm-icon {
  width: 96px;
  height: 96px;
  margin: 0 auto 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 176, 32, 0.15);
  color: #ffb020;
}
.confirm-title {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 10px;
}
.confirm-message {
  color: var(--text-secondary);
  font-size: 15px;
  line-height: 1.75;
  margin-bottom: 28px;
  white-space: pre-line;
}
.confirm-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
